import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBudgetCostCentres(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('budget/cost-center', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBudgetCostCentre(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`budget/cost-center/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
